var React = require('react');

function PlusLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"plus-light","d":"M19.583,72.75H11.25V64.417A.417.417,0,0,0,10.833,64H9.167a.417.417,0,0,0-.417.417V72.75H.417A.417.417,0,0,0,0,73.167v1.667a.417.417,0,0,0,.417.417H8.75v8.333A.417.417,0,0,0,9.167,84h1.667a.417.417,0,0,0,.417-.417V75.25h8.333A.417.417,0,0,0,20,74.833V73.167A.417.417,0,0,0,19.583,72.75Z","transform":"translate(0 -64)"}));
}

PlusLight.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = PlusLight;

PlusLight.default = PlusLight;
